import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit {
  dateNow = new Date();
  date : Date = new Date(2021,0O1,12);
  enableButton : boolean = false;
  constructor() { 
    this.CheckIfDatePassed();
  }

  ngOnInit(): void {
    
  }

  CheckIfDatePassed(){
    if (this.dateNow.valueOf() >= this.date.valueOf()){
      this.enableButton = true;
    }
    console.log('Today:' + this.dateNow.toDateString());
    console.log('Unlock:' + this.date.toDateString());
    console.log(this.enableButton);
  }

}
